import VueComponentLoader from '../components/vue-component-loader';
import { throttle } from 'lodash';

export default class Search {
    constructor(elm) {
        const input = elm.querySelector('[data-search-input]');
        const resultsContainer = elm.querySelector('[data-search-results]');
        const toggle = elm.querySelector('[data-search-toggle]');
        const allResultsLink = elm.querySelector('[data-results-link]');
        const results = elm.querySelector('.search-bar__results');

        function setVisualViewportHeight() {
            // For the rare legacy browsers that don't support it
            if (!window.visualViewport) {
                return;
            }

            document.body.style.setProperty('--actual-height', window.visualViewport.height + 'px');
            if (window.visualViewport.offsetTop >= 0) {
                document.body.style.setProperty('--transform-from-bottom', `-${Math.max(0, window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop)}px`);
            }
        }

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', () => {
                setVisualViewportHeight();
            });

            window.visualViewport.addEventListener('scroll', () => {
                setVisualViewportHeight();
            });
        }

        setVisualViewportHeight();

        toggle.addEventListener('click', () => {
            document.body.classList.toggle('search-bar-open');
            if (document.body.classList.contains('search-bar-open')) {
                input.focus();
            } else {
                window.closeSearch();
            }
        });

        window.closeSearch = () => {
            input.value = '';
            resultsContainer.innerHTML = '';
            elm.classList.remove('search-bar--no-results');
            elm.classList.remove('search-bar--results');
            document.body.classList.remove('search-results-open');
        };

        window.addEventListener('click', e => {
            const closest = e.target.closest('.search-bar');
            if (!closest) {
                document.body.classList.remove('search-bar-open');
            }
        });

        const throttledSearch = throttle(updateSearch, 300);
        let lastSearch = '';

        function updateSearch() {
            if (input.value.length > 2) {
                if (lastSearch != input.value) {
                    const calendarHref = allResultsLink.dataset.calendarHref;
                    allResultsLink.href = `${calendarHref}?Query=${input.value}`;
                    clearSearch();
                    lastSearch = input.value;
                    const curSearch = input.value;
                    fetch(`/umbraco/api/events/fetch?query=${input.value}&pageSize=5`).then(x => x.json())
                        .then(json => {
                            if (curSearch == lastSearch) {
                                if (!json.results || json.results?.length == 0) {
                                    elm.classList.add('search-bar--no-more-results');
                                    elm.classList.add('search-bar--no-results');
                                    elm.classList.remove('search-bar--results');
                                    document.body.classList.remove('search-results-open');
                                } else {
                                    elm.classList.remove('search-bar--no-results');
                                    elm.classList.add('search-bar--results');
                                    document.body.classList.add('search-results-open');
                                    elm.classList.toggle('search-bar--no-more-results', json.results.length < 5);

                                    json.results.forEach(result => {
                                        const div = document.createElement('div');
                                        div.setAttribute('data-vue-component', 'vue-event-card');
                                        resultsContainer.appendChild(div);
                                        result.listView = true;
                                        result.inSearch = true;
                                        new VueComponentLoader(div, result);
                                    });

                                    results.scrollTo(0, 0);
                                }
                            }
                        });
                }
            } else {
                clearSearch();
            }
        }

        function clearSearch() {
            resultsContainer.innerHTML = '';
            elm.classList.remove('search-bar--no-results');
            elm.classList.remove('search-bar--results');
            document.body.classList.remove('search-results-open');
        }

        input.addEventListener('input', () => {
            throttledSearch();
        });
    }
}
